






































































































import Vue from 'vue';
import Component from 'vue-class-component';
import isEqual from 'lodash.isequal';
import isUndefined from 'lodash.isundefined';
import isNull from 'lodash.isnull';
import * as soap from 'soap';
import { Watch }from 'vue-property-decorator';
import genericapi  from '../assets/ts/genericAPIAxios';
import publicinquiryapi  from '../assets/ts/publicinquiryapi';

@Component
export default class EBiennialEmailUpdate extends Vue {
private errors = [];
private label = [];
private regexp: RegExp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
private emailAddress: string = null;
private confirmEmailAddress: string = null;
private errorsMessagesFromDB = [];
private newObject: any = {};

public timeout() {
    setTimeout(() => {
        console.log('Test');
        // this.newObject = this.$store.getters['ebiennial/EBiennialFiling'];
        console.log(this.newObject);
    }, 500);
}

private created() {
    const http = this.$http;
    this.newObject = this.$store.getters['ebiennial/EBiennialFiling'];
    console.log('Inside created of email update page');
    console.log('getting object from store');
    console.log(this.newObject);
    if (this.empty(this.label) || this.label.length === 0) {
     this.fetchLabels().then((labelResponse: any) => {
       console.log(labelResponse);
       this.label = labelResponse;
      });
    }
    console.log('Fetching errors from database');
    genericapi.get('Generic/GetConfigurationData', {
      params: {
      group: 'ERROR',
      application: 'EBIENNIAL',
    },

    }).then((response: any) => {
      console.log(response);
      this.errorsMessagesFromDB = response.data;
      }).catch((error: any) => {
      // this.error = error
      console.log(error);
    });
    this.searchEntity().then((entityRecordResponse: any) => {
     if (entityRecordResponse.requestStatus = 'Success' && entityRecordResponse.resultIndicator != 'InvalidID')  {
        this.newObject.dosFilingDate = entityRecordResponse.entityGeneralInfo.effectiveDateInitialFiling;
        this.newObject.county = entityRecordResponse.entityGeneralInfo.county;
        this.newObject.jurisdiction = entityRecordResponse.entityGeneralInfo.jurisdiction;
        this.newObject.entityTypeDesc = entityRecordResponse.entityGeneralInfo.entityType;
    }
   });
    this.timeout();
  }
  private getLabelValue(label: string) {
    for (let i = 0; i < this.label.length; i++) {
      for (const key in this.label[i] ) {
        if (key === label) {
          console.log('Matched if');
          return this.label[i][key];
        }

      }
    }
  }

  private populateError(errorCode: string): void {
  console.log('error code passed:' + errorCode);
  for (let i = 0; i < this.errorsMessagesFromDB.length; i++) {
      for (const key in this.errorsMessagesFromDB[i] ) {
        console.log( key + ' == ' +  this.errorsMessagesFromDB[i][key]);
        if (key === errorCode) {
          console.log('found error code match');
          this.errors.push(this.errorsMessagesFromDB[i][key]);
        }

      }
  }
}

  private searchEntity() {
      return publicinquiryapi.post('PublicInquiry/GetEntityRecordByID', {
                SearchID: this.newObject.dosId,
                AssumedNameFlag: false,
      // SubmitterInfo: this.SubmitterInfo
    }).then((response: any) => {
      console.log('Got result from public inquiry');
      console.log(response.data);
      return response.data;
    }).catch((error: any) => {
      // this.error = error
      console.log(error);
      // this.errors.push(error);
    });
   }

 private fetchLabels() {
     return genericapi.get('Generic/GetConfigurationData', {
          params: {
          group: 'SECTION',
          application: 'EBIENNIAL',
      },

    }).then((response: any) => {
      console.log(response);
      return response.data;
    }).catch((error: any) => {
      console.log(error);
    });
  }
  private submitApplication() {
      this.errors.length = 0;
      this.validateInput();
      if (this.errors.length == 0) {
        this.saveFinalTransaction().then((finalResponse: any) => {
        console.log(finalResponse);
        if (finalResponse.eBiennialEmailUpdateResult.requestStatus==='Success') {
            this.$router.push({ name: 'emailUpdateApproved' });
        } else {
            this.$router.push({ name: 'emailUpdateIssue' });
        }
        }).catch((error: any) => {
        console.log(error);
        this.$router.push({ name: 'emailUpdateIssue' });
        });

    }

  }
  private validateInput() {
      console.log('this.emailAddress:' + this.emailAddress);
      console.log('this.confirmEmailAddress:' + this.confirmEmailAddress);
      if (!this.validateEmail(this.emailAddress)) {
          this.populateError('ERR029');
      }
      if (!this.validateEmail(this.confirmEmailAddress)) {
          this.populateError('ERR030');
      }
      if (this.emailAddress.localeCompare(this.confirmEmailAddress, 'en-US', { sensitivity: 'base' }) != 0) {
          this.populateError('ERR031');
      }

  }
   private saveFinalTransaction() {
    return this.$http.post('Ebiennial/EBiennialEmailData', {
      req: {
        EmailAddress: this.emailAddress,
        dosid: this.newObject.dosId,
        entityname: this.newObject.entityName,
      },

        }).then((response: any) => {
        return response.data;
        console.log('finished saving data');
        console.log(response);
        }).catch((error: any) => {
        // this.error = error
        console.log(error);
        });
}
  private validateEmail(emailInput: string) {
      if (!this.empty(emailInput)) {
        console.log('output of expression:' + this.regexp.test(emailInput));
        return this.regexp.test(emailInput);
      } else {
          return false;
      }

        // return re.match(emailInput);
  }
  private empty(e) {
    switch (e) {
      case '':
      case '':
      case 0:
      case '0':
      case null:
      case false:
      case typeof this === 'undefined':
      case undefined:
      return true;
      default:
        return false;
    }
  }
}
